import { useEffect } from "react";

export function useDisableImageContextMenu() {
	useEffect(() => {
		function onContextMenu(e: Event) {
			if (e.target && (e.target as any).tagName === "IMG") {
				e.preventDefault();
			}
		}

		window.addEventListener("contextmenu", onContextMenu);

		return () => window.addEventListener("contextmenu", onContextMenu);
	}, []);
}
